<!-- client/src/views/Admin/LogManagement.vue -->
<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>
          Log Management
          <v-btn  variant="outlined" class="float-right" @click="refreshLogs" color="primary">
              Refresh
          </v-btn>
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="logs"
          :items-per-page="30"
          class="elevation-1"
        >
          <template v-slot:item.aquarium_id="{ item }">
            <router-link :to="{ name: 'Aquarium Management', query: { id: item.aquarium_id } }">
              {{ item.aquarium_id }}
            </router-link>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn class="edit-button" @click="this.modalStore.openDataLogModal({ mode:'admin', verb:'edit', prefilledData: item })" color="primary" rounded="xl" size="x-small">Edit</v-btn>
            <v-btn class="danger-button" @click="this.modalStore.openDataLogModal({ mode:'admin', verb:'delete', prefilledData: item })" color="error" rounded="xl" size="x-small">Delete</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn variant="outlined" class="float-right" color="primary" @click="this.modalStore.openDataLogModal({mode:'admin', verb:'create', prefilledData:{}})">
          Create New
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="showDeleteModal" max-width="500px">
      <v-card>
        <v-card-title class="headline">Confirm Deletion</v-card-title>
        <v-card-text>Are you sure you want to delete this log?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="red darken-1" @click="deleteLog(confirmItemId)">Yes</v-btn>
          <v-btn class="green darken-1" @click="showDeleteModal = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios';
import { usePopupStore } from '@/store';
import { useModalStore } from '@/store';
import { useHead } from '@vueuse/head';

export default {
  name: 'LogManagement',
  setup() {
    useHead({
      title: 'Reeflendar.com - Log Management',
      meta: [
        { name: 'description', content: 'Manage logs in Reeflendar.' },
        { name: 'keywords', content: 'admin, log management, aquarium' },
      ],
    });
    return {
      popupStore: usePopupStore(),
      modalStore: useModalStore(),
    };
  },
  data() {
    return {
      logs: [],
      newLog: {
        aquarium_id: '',
        timestamp: '',
        temperature: '',
        ph: '',
        salinity: '',
        note: '',
      },
      editItem: {},
      showDeleteModal: false,
      showEditModal: false,
      confirmItemId: null,
      headers: [
        { title: 'ID', value: 'id' },
        { title: 'Aquarium ID', value: 'aquarium_id' },
        { title: 'Timestamp', value: 'timestamp' },
        { title: 'Temperature', value: 'temperature' },
        { title: 'pH', value: 'ph' },
        { title: 'Salinity', value: 'salinity' },
        { title: 'Note', value: 'note' },
        { title: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  methods: {
    getCurrentDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      let hour = now.getHours();
      const minute = String(now.getMinutes()).padStart(2, '0');
      const ampm = hour >= 12 ? 'PM' : 'AM';
      hour = hour % 12;
      hour = hour ? hour : 12; // the hour '0' should be '12'
      const strTime = `${year}-${month}-${day} ${hour}:${minute} ${ampm}`;
      return strTime;
    },
    async fetchLogs() {
      try {
        const response = await axios.get('/api/logs/');
        const aquariumId = this.$route.query.aquarium_id;
        if (aquariumId) {
          this.logs = response.data.filter(log => log.aquarium_id == aquariumId);
        } else {
          this.logs = response.data;
        }
        
      } catch (error) {
        this.popupStore.setMessage('Error fetching logs', error.message);
      }
    },
    refreshLogs() {
      this.$router.push({ query: {} }).then(() => {
        this.fetchLogs();
      });
    },
    confirmDeleteLog(logId) {
      this.confirmItemId = logId;
      this.showDeleteModal = true;
    },
    async deleteLog(logId) {
      try {
        await axios.delete(`/api/logs/${logId}`);
        this.logs = this.logs.filter(log => log.id !== logId);
        this.showDeleteModal = false;
      } catch (error) {
        this.popupStore.setMessage('Error deleting log', error);
      }
    },
  },
  mounted() {
    this.fetchLogs();
    this.$eventBus.on('log-updated', this.fetchLogs);
  },
  beforeUnmount() {
    this.$eventBus.off('log-updated', this.fetchLogs);
  },
};
</script>